export const GET_BOOK_LIST_REQUEST = "get/book/list/request";
export const GET_BOOK_LIST_SUCCESS = "get/book/list/success";
export const GET_BOOK_LIST_ERROR = "get/book/list/error";
export const GET_EXPIRED_BOOKS_REQUEST = "get/expired/book/request";
export const GET_EXPIRED_BOOKS_SUCCESS = "get/expired/book/success";
export const GET_EXPIRED_BOOKS_FAILURE = "get/expired/book/error";
export const GET_BOOK_LIST_INTERMEDIATE_RESPONSE =
  "get/book/list/intermediate/response";
export const GET_BOOK_INFO_REQUEST = "get/book/info/request";
export const GET_BOOK_INFO_SUCCESS = "get/book/info/success";
